<!-- header for an existing channel -->
<div class="page-heading-blue pt-3 pb-3 pl-2">
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-3 col-xl-4">
        <div class="headerText">
          {{'PROGRAM' | translate}}&nbsp;<i
            class="fal fa-angle-right fa-lg"></i>&nbsp;{{channel?.program?.name}}&nbsp;<i
            class="fal fa-angle-right fa-lg"></i>&nbsp;
          {{'CHANNEL' | translate}}&nbsp;<i class="fal fa-angle-right fa-lg"></i>
        </div>
        <div class="headerText" *ngIf="!loading">
          <h2>{{channel.name}}</h2>
        </div>
      </div>
      <div *ngIf="!loading" class="col-sm-6 col-md-4 col-lg-3 col-xl-3 my-auto text-nowrap header-timestamp">
        <label class="text-right headerText">{{'LAST-MODIFIED-BY' | translate}}:</label>
        <span class="ml-2">{{channel.lastModifiedBy}}</span>
        <br />
        <label class="text-right headerText">{{'LAST-MODIFIED-DATE' | translate}}:</label>
        <span class="ml-2">{{channel.lastModifiedOn | date:'medium'}}</span>
      </div>
      <div *ngIf="!loading" class="col-sm-6 col-md-4 col-lg-3 col-xl-3 my-auto text-nowrap header-timestamp">
        <label class="text-right headerText">{{'CREATED-BY' | translate}}:</label>
        <span class="ml-2">{{channel.createdBy}}</span>
        <br />
        <label class="text-right headerText">{{'CREATED-DATE' | translate}}:</label>
        <span class="ml-2">{{channel.createdOn | date:'medium'}}</span>
      </div>
      <div *ngIf="!loading"
        class="col-sm-2 col-md-4 col-lg-2 col-xl-2 my-auto align-right text-nowrap header-timestamp">
        <label *ngIf="channel.status !== 'Template'" class="text-right headerText"
          style="position: relative;top: -5px;margin-bottom: 0;">{{'STATUS' | translate}}:
        </label>
        <span class="ml-2 badge badge-pill channel-status text-uppercase" [ngClass]="{
        'channel-status-offline': channel.status === 'Offline',
        'channel-status-simulated': channel.status === 'Simulated', 
        'channel-status-online': channel.status === 'Online',
        'channel-status-deleted': channel.status === 'Deleted',
        'channel-status-template': channel.status === 'Template',
        'channel-status-archived': channel.status === 'Archived'}">{{getChannelStatusKey(channel.status) |
          translate}}</span>
        <br />
        <label class="text-right headerText">{{'VERSION' | translate}}:</label>
        <span class="ml-2">{{channel.version}}</span>
        <div>
          <button class="btn btn-outline-light" (click)="backToProgramEdit()">
            {{ 'BACK-TO-PROGRAM-EDIT' | translate }}
            <i class="arrow fal fa-angle-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!--Loading div-->
<div *ngIf="loading" class="page-wrap d-flex flex-row align-items-center mt-5">
  <div class="container">
    <div class="row justify-content-center">
      <span class="k-icon k-i-loading kendo-loading-icon"></span>
    </div>
  </div>
</div>

<kendo-tabstrip *ngIf="!loading">
  <kendo-tabstrip-tab title="{{ 'SUMMARY' | translate }}" [selected]="true">
    <ng-template kendoTabContent>
      <!-- Channel form -->
      <form [formGroup]="channelForm" class="k-form" style="padding:2rem!important;">
        <div class="secondary-card">
          <div class="secondary-card-header">
            <h5 class="collapsible-text" (click)="channelDetailsCollapsible.toggleChange()">
              {{'CHANNEL-DETAILS-SECTION-HEADER' | translate}}
              <app-collapsible #channelDetailsCollapsible [storageKey]="'channel-edit-details'"
                (collapsibleToggle)="channelDetailsCollapsed=$event">
              </app-collapsible>
            </h5>
          </div>
          <div class="card-body" *ngIf="!channelDetailsCollapsed">
            <div class="row">
              <!-- Channel name and description -->
              <div class="col-sm-6">
                <!-- Groups -->
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'ASSIGNED-STAFF-GROUPS' | translate}}
                    <span style="display: inline-flex">
                      <div #tipA kendoTooltip position="right" class="keyboard-accessible" tabindex="0" showOn="none"
                        (focus)="showTooltip(assignedStaffGroupsTooltip,tipA)" aria-live="polite"
                        (mouseover)="showTooltip(assignedStaffGroupsTooltip,tipA)" (blur)="hideTooltip(tipA)"
                        (mouseout)="hideTooltip(tipA)">
                        <a #assignedStaffGroupsTooltip
                          title="{{'INFO-PROGRAM-ASSIGNED-STAFF-GROUP' | translate:patientLabel}}"><i
                            class="fa fa-info-circle pointer"></i></a>
                      </div>
                    </span>
                  </span>
                  <kendo-multiselect [data]="channelGroupsFiltered" formControlName="groups" [textField]="'name'"
                    [filterable]="true" [valueField]="'id'" [autoClose]="true" [itemDisabled]="groupItemDisabled"
                    (removeTag)="setStaffCandidates()" (clickOutside)="setStaffCandidates()">
                    <ng-template kendoMultiSelectItemTemplate let-dataItem>
                      <div class="m-1">
                        <input type="checkbox" [checked]="isGroupSelected('groups', dataItem.id)" kendoCheckBox />
                        <label class="k-checkbox-label">{{ dataItem.name }}</label>
                      </div>
                    </ng-template>
                  </kendo-multiselect>
                  <div>
                    <a *ngIf="isGroupsSelected()" class="pointer float-right montserrat" (click)="showGroupMember()">
                      {{'SHOW-STAFF' | translate}}
                    </a>
                  </div>
                </label>
                <!-- Selected Channel Staff -->
                <div>
                  <span class="k-text-uppercase dark k-form-field">{{'PROGRAM-PARTICIPANTS' | translate}}
                    <span style="display: inline-flex">
                      <div #tipB kendoTooltip position="right" class="keyboard-accessible" tabindex="0" showOn="none"
                        (focus)="showTooltip(assignedStaffProgramTooltip,tipB)" aria-live="polite"
                        (mouseover)="showTooltip(assignedStaffProgramTooltip,tipB)" (blur)="hideTooltip(tipB)"
                        (mouseout)="hideTooltip(tipB)">
                        <a #assignedStaffProgramTooltip
                          title="{{'INFO-PROGRAM-ASSIGNED-STAFF' | translate:patientLabel}}"><i
                            class="fa fa-info-circle pointer"></i></a>
                      </div>
                    </span>
                  </span>
                  <kendo-grid [data]="staffGrid.gridData"
                    [pageable]="staff.length > staffGrid.state.take ? { buttonCount: 5, pageSizes: pageSizes} : false"
                    [pageSize]="staffGrid.state.take" [skip]="staffGrid.state.skip" [sortable]="true"
                    [sort]="staffGrid.state.sort" (dataStateChange)="staffGrid.setState($event)"
                    (cancel)="staffCancelHandler($event)" (save)="staffSaveHandler($event)"
                    (add)="staffAddHandler($event)">
                    <kendo-grid-messages noRecords="{{ 'NO-STAFF' | translate }}"></kendo-grid-messages>
                    <kendo-grid-column field="name" [width]="70" title="{{'NAME' | translate}}">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <span [ngClass]="{'disabled-record-text': !dataItem.enabled}">{{
                          dataItem.name}}</span>&nbsp;<span
                          class="disabled-record-text">{{setRecordStateText(dataItem)}}</span>
                      </ng-template>
                      <ng-template kendoGridEditTemplate>
                        <kendo-combobox id="staffDropdown" [data]="staffCandidatesFiltered" [textField]="'name'"
                          [valueField]="'id'" [filterable]="true" (filterChange)="filterStaffCandidates($event)"
                          (close)="searchTerm=''" [(value)]="newStaffMember" [itemDisabled]="staffItemDisabled">
                          <ng-template kendoComboBoxItemTemplate let-dataItem>
                            <span innerHTML="{{ dataItem.name | highlight : searchTerm }}">
                            </span>
                          </ng-template>
                        </kendo-combobox>
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-command-column [width]="30" class="text-center" [hidden]="disableFormControl()">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <ng-container *ngIf="!dataItem.editing">
                          <i class="fas fa-trash-alt fa-lg" title="{{'DELETE' | translate}}"
                            (click)="deleteStaff(dataItem)"></i>
                        </ng-container>
                        <ng-container *ngIf="dataItem.editing">
                          <ng-container *ngIf="newStaffMember !== null && newStaffMember !== undefined">
                            <i class="fas fa-check fa-lg icon-success pointer" title="{{'SAVE' | translate}}"
                              (click)="staffSaveButton.click.emit($event); dataItem.editing = false;">
                            </i>
                            &nbsp;
                          </ng-container>
                          <i class="fas fa-times-circle fa-lg icon-neutral pointer" title="{{'CANCEL' | translate}}"
                            (click)="staffCancelButton.click.emit($event); dataItem.editing = false;"></i>
                          <button kendoGridSaveCommand #staffSaveButton class="d-none"></button>
                          <button kendoGridCancelCommand #staffCancelButton class="d-none"></button>
                        </ng-container>
                      </ng-template>
                    </kendo-grid-command-column>
                    <button kendoGridAddCommand #staffAddButton class="d-none" (click)="setStaffCandidates()"></button>
                  </kendo-grid>
                  <button appPreventClick kendoButton [primary]="false" type="button" class="float-right mt-3"
                    (click)="staffAddButton.click.emit($event)" [disabled]="disableFormControl()">
                    {{'ADD' | translate}}<i class="far fa-user-plus"></i>
                  </button>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="row">
                  <!-- Channel category -->
                  <div class="col-sm-6">
                    <label class="k-form-field mb-0">
                      <span class="k-text-uppercase dark">
                        {{'CHANNEL-EDIT-CATEGORY' | translate}}<span style="display: inline-flex">
                          <div #tipC kendoTooltip position="bottom" class="mr-1 keyboard-accessible" tabindex="0"
                            showOn="none" (focus)="showTooltip(categoryHintTooltip,tipC)" aria-live="polite"
                            (mouseover)="showTooltip(categoryHintTooltip,tipC)" (blur)="hideTooltip(tipC)"
                            (mouseout)="hideTooltip(tipC)">
                            <a #categoryHintTooltip title="{{'WIZARD-CHANNEL-CATEGORY-HINT' | translate }}"><i
                                class="fa fa-info-circle pointer ml-2"></i></a>
                          </div>
                        </span>
                      </span> <span *ngIf="workflowStatusInUse && !disableFormControl()" style="display: inline-flex">
                        <div #tipD kendoTooltip position="right" class="keyboard-accessible" tabindex="0" showOn="none"
                          (focus)="showTooltip(categoryWarningTooltip,tipD)" aria-live="polite"
                          (mouseover)="showTooltip(categoryWarningTooltip,tipD)" (blur)="hideTooltip(tipD)"
                          (mouseout)="hideTooltip(tipD)">
                          <a #categoryWarningTooltip title="{{'WARNING-CHANNEL-CATEGORY' | translate}}"><i
                              class="fas fa-exclamation-triangle icon-warn pointer"></i></a>
                        </div>
                      </span>
                      <kendo-combobox id="channelCategoryDropdown" [data]="channelCategoriesFiltered"
                        [valueField]="'id'" [textField]="'name'" formControlName="channelCategory" [filterable]="true"
                        [itemDisabled]="categoryItemDisabled" (filterChange)="filterChannelCategories($event)"
                        class="w-100">
                      </kendo-combobox>
                    </label>
                  </div>
                  <!-- Case Manager Assignment -->
                  <div class="col-sm-6 pl-0">
                    <label class="k-form-field mb-0">
                      <span class="k-text-uppercase dark">
                        {{'CASE-MANAGER-ASSIGNMENT' | translate}}<span style="display: inline-flex">
                          <div #tipE kendoTooltip position="bottom" class="mr-1 keyboard-accessible" tabindex="0"
                            showOn="none" (focus)="showTooltip(caseManagerTooltip,tipE)" aria-live="polite"
                            (mouseover)="showTooltip(caseManagerTooltip,tipE)" (blur)="hideTooltip(tipE)"
                            (mouseout)="hideTooltip(tipE)">
                            <a #caseManagerTooltip title="{{'WIZARD-CASE-MANAGER-HINT' | translate }}"><i
                                class="fa fa-info-circle pointer ml-2"></i></a>
                          </div>
                        </span>
                      </span>
                      <kendo-combobox id="caseManagerAssignmentModeDropdown" [data]="caseManagerAssignmentModes"
                        [valueField]="'value'" [textField]="'text'" formControlName="caseManagerAssignmentMode"
                        class="w-100" [valuePrimitive]="true">
                      </kendo-combobox>
                    </label>
                  </div>
                </div>
                <!--Program Description-->
                <label class="k-form-field">
                  <span class="k-text-uppercase dark">
                    {{'PROGRAM-DESCRIPTION' | translate}} *
                  </span>
                  <textarea kendoTextArea rows="5" formControlName="description" maxlength="1024"
                    class="w-100"></textarea>
                  <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="formFieldInvalid('description')">
                    {{'REQUIRED-DESCRIPTION' | translate}}
                  </div>
                </label>
                <div class="row">
                  <!--Sensitivity Flags-->
                  <div class="col-12">
                    <label for="sensitivities" class="k-form-field">
                      <span class="k-text-uppercase dark">
                        {{ 'RESTRICTED-DATA-REASONS' | translate }}
                      </span>
                      <kendo-multiselect id="sensitivities" [data]="sensitivitiesFiltered"
                        formControlName="sensitivities" [textField]="'displayName'" [filterable]="true"
                        [valueField]="'id'" (filterChange)="filterSensitivities($event)"
                        (close)="searchTermSensivity=''" [autoClose]="true" [virtual]="virtualSensitivity"
                        style="max-height: 137px; overflow: auto;" [valuePrimitive]="true">
                        <ng-template kendoMultiSelectItemTemplate let-dataItem>
                          <span innerHTML="{{ dataItem.displayName | highlight : searchTermSensivity }}"
                            class="ellipsis-text">
                          </span>
                        </ng-template>
                      </kendo-multiselect>
                    </label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <!--Limited Enrollment-->
                    <div class="k-form-field">
                      <input type="checkbox" id="limitedEnrollment" formControlName="limitedEnrollment" kendoCheckBox>
                      <label class="k-checkbox-label k-text-uppercase dark" for="limitedEnrollment"
                        [ngClass]="{'k-disabled': disableFormControl()}">{{ 'LIMITED-ENROLLMENT' | translate }}<span
                          style="display: inline-flex">
                          <div #tipF kendoTooltip position="top" class="mr-1 keyboard-accessible" tabindex="0"
                            showOn="none" (focus)="showTooltip(limitedEnrollmentTooltip,tipF)" aria-live="polite"
                            (mouseover)="showTooltip(limitedEnrollmentTooltip,tipF)" (blur)="hideTooltip(tipF)"
                            (mouseout)="hideTooltip(tipF)">
                            <a #limitedEnrollmentTooltip title="{{'WIZARD-LIMITED-ENROLLMENT-HINT' | translate }}"><i
                                class="fa fa-info-circle pointer ml-2"></i></a>
                          </div>
                        </span>
                      </label>
                    </div>
                  </div>
                  <div class="col-6">
                    <!--Limited View-->
                    <div class="k-form-field">
                      <input type="checkbox" id="limitedView" formControlName="limitedView" kendoCheckBox>
                      <label class="k-checkbox-label k-text-uppercase dark" for="limitedView"
                        [ngClass]="{'k-disabled': disableFormControl()}">{{ 'LIMITED-VIEW' | translate }}<span
                          style="display: inline-flex">
                          <div #tipG kendoTooltip position="top" class="mr-1 keyboard-accessible" tabindex="0"
                            showOn="none" (focus)="showTooltip(limitedViewTooltip,tipG)" aria-live="polite"
                            (mouseover)="showTooltip(limitedViewTooltip,tipG)" (blur)="hideTooltip(tipG)"
                            (mouseout)="hideTooltip(tipG)">
                            <a #limitedViewTooltip title="{{'WIZARD-LIMITED-VIEW-HINT' | translate }}"><i
                                class="fa fa-info-circle pointer ml-2"></i></a>
                          </div>
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <!--Referral-->
                    <div class="k-form-field">
                      <input type="checkbox" id="referral" formControlName="referral" kendoCheckBox>
                      <label class="k-checkbox-label k-text-uppercase dark" for="referral"
                        [ngClass]="{'k-disabled': disableFormControl()}">{{ 'REFERRAL' | translate }}<span
                          style="display: inline-flex">
                          <div #tipH kendoTooltip position="top" class="mr-1 keyboard-accessible" tabindex="0"
                            showOn="none" (focus)="showTooltip(referralHintTooltip,tipH)" aria-live="polite"
                            (mouseover)="showTooltip(referralHintTooltip,tipH)" (blur)="hideTooltip(tipH)"
                            (mouseout)="hideTooltip(tipH)">
                            <a #referralHintTooltip title="{{'WIZARD-REFERRAL-HINT' | translate }}"><i
                                class="fa fa-info-circle pointer ml-2"></i></a>
                          </div>
                        </span>
                      </label>
                    </div>
                  </div>
                  <div class="col-6">
                    <!--Private-->
                    <div class="k-form-field">
                      <input type="checkbox" id="private" formControlName="private" kendoCheckBox>
                      <label class="k-checkbox-label k-text-uppercase dark" for="private"
                        [ngClass]="{'k-disabled': disableFormControl()}">{{ 'PRIVATE' | translate }}<span
                          style="display: inline-flex">
                          <div #tipI kendoTooltip position="top" class="mr-1 keyboard-accessible" tabindex="0"
                            showOn="none" (focus)="showTooltip(privateTooltip,tipI)"
                            (mouseover)="showTooltip(privateTooltip,tipI)" (blur)="hideTooltip(tipI)"
                            (mouseout)="hideTooltip(tipI)" aria-live="polite">
                            <a #privateTooltip title="{{'WIZARD-PRIVATE-HINT' | translate }}"><i
                                class="fa fa-info-circle pointer ml-2"></i></a>
                          </div>
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <!--Dashboard Enrollment-->
                  <div class="col-6">
                    <div class="k-form-field">
                      <input type="checkbox" id="dashboardEnrollment" formControlName="dashboardEnrollment"
                        kendoCheckBox>
                      <label class="k-checkbox-label k-text-uppercase dark" for="dashboardEnrollment"
                        [ngClass]="{'k-disabled': disabledDashboardEnrollment()}">{{ 'DASHBOARD-ENROLLMENT' | translate
                        }}<span style="display: inline-flex">
                          <div #tipJ kendoTooltip position="top" class="mr-1 keyboard-accessible" tabindex="0"
                            showOn="none" (focus)="showTooltip(dashboardEnrollmentTooltip,tipJ)" aria-live="polite"
                            (mouseover)="showTooltip(dashboardEnrollmentTooltip,tipJ)" (blur)="hideTooltip(tipJ)"
                            (mouseout)="hideTooltip(tipJ)">
                            <a #dashboardEnrollmentTooltip
                              title="{{'WIZARD-DASHBOARD-ENROLLMENT-HINT' | translate }}"><i
                                class="fa fa-info-circle pointer ml-2"></i></a>
                          </div>
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- rules and processes -->
        <div class="secondary-card mt-4">
          <div class="secondary-card-header">
            <h5 class="collapsible-text" (click)="channelEditCollapsible.toggleChange()">{{ 'PROGRAM-SECTION-HEADER' |
              translate}}
              <app-collapsible #channelEditCollapsible [storageKey]="'channel-edit-channel'"
                (collapsibleToggle)="channelCollapsed=$event">
              </app-collapsible>
            </h5>
          </div>
          <div class="card-body pt-2 pl-0 pr-0 pb-0" *ngIf="!channelCollapsed">
            <div class="container-fluid pl-0 pr-0">
              <div class="mt-2 mb-2">
                <div class="row ml-2 mb-3">
                  <div class="ml-3 pt-2">
                    <span class="k-text-uppercase dark channel-label">
                      {{'CHANNEL' | translate}}
                    </span>
                  </div>
                  <div class="col-5">
                    <input id="name" kendoTextBox formControlName="name" class="w-100"
                      (keydown)="validateKey($event)" />
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                      *ngIf="name.touched && name.errors?.required">
                      {{'REQUIRED-NAME' | translate}}
                    </div>
                    <div class="k-tooltip k-tooltip-validation" role="alert"
                      *ngIf="name.touched && name.errors?.maxlength">
                      {{'NAME-LONGER-THAN-255' | translate}}
                    </div>
                  </div>
                  <div class="my-auto pl-0">
                    <!-- Business Process -->
                    <button kendoButton type="button" (click)="configureChannel(channel.bpmId)"
                      *ngIf="!configureChannelDisabled" [disabled]="disableFormControl()">
                      {{'CONFIGURE-CHANNEL' | translate}}&nbsp;
                    </button>
                    <i *ngIf="channel.appId !== null && !configureChannelDisabled" class="fas fa-download ml-3"
                      title="{{'EXPORT-CHANNEL' | translate}}" (click)="exportModel()">
                    </i>
                    <i *ngIf="!(channel.appId !== null) && !configureChannelDisabled && channel.status !== 'Template'"
                      class="fas fa-download ml-3 icon-disabled" title="{{'EXPORT-CHANNEL' | translate}}">
                    </i>
                  </div>
                </div>
                <kendo-tabstrip #tabstrip>
                  <kendo-tabstrip-tab title="{{ 'MEMBER-ENROLLMENT' | translate:patientLabel }}" [selected]="true">
                    <ng-template kendoTabContent>
                      <div class="ml-2">
                        <!--Manual Enrollment-->
                        <div class="font-weight-bold mt-2">
                          {{'MANUAL-ENROLLMENT' | translate}}
                        </div>
                        <div class="pb-3 channel-description">
                          {{'MANUAL-ENROLLMENT-DESCRIPTION' | translate:patientLabelLower}}
                        </div>
                        <!-- enroll members -->
                        <div *ngIf="channel.status !== 'Template'">
                          <button kendoButton type="button" (click)="checkChannelStatus()" [disabled]="channel.bpmId === null || disableFormControl() || channel.deployedBpmId === null 
                          || channel.status === 'Offline' || channel.status === 'Archived'">
                            {{'ENROLL-MEMBER' | translate:patientLabel}}<i class="far fa-user-plus"></i>
                          </button>
                        </div>
                        <br />
                      </div>
                      <!--Automated Enrollment-->
                      <div class="font-weight-bold mt-2 ml-2">
                        {{'AUTOMATED-ENTROLLMENT' | translate}}
                      </div>
                      <div class="pb-3 channel-description ml-2">
                        {{'AUTOMATED-ENTROLLMENT-DESCRIPTION' | translate:patientLabelLower}}
                      </div>

                      <!-- Enrollment Rule -->
                      <div class="col-sm-5 pb-3 pl-0 ml-2" formArrayName="entryRules"
                        *ngFor="let item of channelForm.get('entryRules').controls; let i = index;">
                        <div [formGroupName]="i">
                          <div>
                            <input kendoTextBox formControlName="name" maxlength="100"
                              style="width:80%; display:inline-block;" />
                            <i *ngIf="channelForm.controls.entryRules.controls[i].controls.id.value"
                              class="fas fa-lg ml-3"
                              title="{{(disableFormControl() ? 'VIEW-ENROLLMENT-RULES' : 'EDIT-ENROLLMENT-RULES') | translate}}"
                              [ngClass]="{'fa-edit': !disableFormControl(),'fa-eye': disableFormControl()}"
                              (click)="onEditRules(channelForm.controls.entryRules.controls[i].controls.id.value)"></i>
                          </div>
                          <div class="k-tooltip k-tooltip-validation" role="alert"
                            [hidden]="channelForm.controls.entryRules.controls[i].controls.name.valid || 
                                                      channelForm.controls.entryRules.controls[i].controls.name.pristine">
                            {{ 'ENROLLMENT-CRITERIA-REQUIRED' | translate }}
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </kendo-tabstrip-tab>
                  <kendo-tabstrip-tab title="{{ 'EVENT-PROCESSING' | translate }}">
                    <ng-template kendoTabContent>
                      <!--Automated Enrollment-->
                      <ng-container>
                        <div class="font-weight-bold mt-2 ml-2">
                          {{'FULFILLMENT-RULES' | translate}}
                        </div>
                        <div class="pb-3 channel-description ml-2">
                          {{'FULFILLMENT-RULES-DESCRIPTION' | translate}}
                        </div>
                        <div class="pb-4 ml-2 mr-2 border-bottom" formArrayName="updateRules"
                          *ngFor="let item of channelForm.get('updateRules').controls; let i = index;"
                          [ngClass]="{'mt-4': i > 0, 'mb-4': i === channelForm.get('updateRules').controls.length-1}">
                          <div class="row">
                            <!-- Rules -->
                            <div class="col-sm-5" [formGroupName]="i">
                              <div>
                                <input kendoTextBox formControlName="name" maxlength="100"
                                  style="width:80%; display:inline-block;" />
                                <i *ngIf="channelForm.controls.updateRules.controls[i].controls.id.value"
                                  class="fas fa-lg ml-3"
                                  [ngClass]="{'fa-edit': !disableFormControl(),'fa-eye': disableFormControl()}"
                                  title="{{(disableFormControl() ? 'VIEW-FULFILLMENT-RULES' : 'EDIT-FULFILLMENT-RULES') | translate}}"
                                  (click)="onEditRules(channelForm.controls.updateRules.controls[i].controls.id.value)"></i>
                              </div>
                              <div class="k-tooltip k-tooltip-validation" role="alert" [hidden]="channelForm.controls.updateRules.controls[i].controls.name.valid || 
                                                channelForm.controls.updateRules.controls[i].controls.name.pristine">
                                {{ 'UPDATE-CRITERIA-REQUIRED' | translate }}
                              </div>
                            </div>
                            <div class="col-sm-4" [formGroupName]="i" style="max-width:28%">
                              <kendo-combobox id="updateType" formControlName="updateType" class="w-100"
                                [valuePrimitive]="true" (open)="updateTypeItemOpen()" [data]="updateTypes"
                                [textField]="'text'" [valueField]="'value'" [itemDisabled]="updateTypeItemDisabled"
                                (valueChange)="handleUpdateTypeChange($event, i)">
                              </kendo-combobox>
                              <div class="k-tooltip k-tooltip-validation" role="alert"
                                [hidden]="channelForm.controls.updateRules.controls[i].controls.updateType.valid || 
                                                                  channelForm.controls.updateRules.controls[i].controls.updateType.pristine">
                                {{ 'RULESET-UPDATE-TYPE-REQUIRED' | translate }}
                              </div>
                            </div>
                            <div class="col-sm-3" [formGroupName]="i">
                              <div>
                                <div class="k-tooltip k-tooltip-validation" role="alert"
                                  [hidden]="channelForm.controls.updateRules.controls[i].controls.assignee.valid || 
                                                                  channelForm.controls.updateRules.controls[i].controls.assignee.pristine">
                                  {{ 'UPDATE-TASK-ASSIGNEE-REQUIRED' | translate }}
                                </div>
                                <div class="k-tooltip k-tooltip-validation" role="alert"
                                  [hidden]="channelForm.controls.updateRules.controls[i].controls.priority.valid || 
                                                                  channelForm.controls.updateRules.controls[i].controls.priority.pristine">
                                  {{ 'UPDATE-TASK-PRIORITY-REQUIRED' | translate }}
                                </div>
                                <div>
                                  <!-- Tasks to update -->
                                  <kendo-multiselect class="w-100"
                                    *ngIf="channelForm.controls.updateRules.controls[i].controls.updateType.value === 'CLOSE_TASKS' ||
                                channelForm.controls.updateRules.controls[i].controls.updateType.value === 'CHANGE_TASKS_ASSIGNEE' ||
                                channelForm.controls.updateRules.controls[i].controls.updateType.value === 'CHANGE_TASKS_PRIORITY'"
                                    [valuePrimitive]=" false" [data]="tasks" formControlName="taskIds"
                                    [textField]="'name'" [valueField]="'id'"
                                    style="display:inline-block; background-color:white; margin-right:1em;">
                                  </kendo-multiselect>
                                </div>
                                <div>
                                  <!-- Task to close -->
                                  <kendo-combobox class="w-100"
                                    *ngIf="channelForm.controls.updateRules.controls[i].controls.updateType.value === 'CLOSE_CONDITIONAL_WAIT'"
                                    [valuePrimitive]=" false" [data]="conditionalWaits"
                                    formControlName="conditionalWaitId" (valueChange)="loadOutcomes($event)"
                                    [textField]="'name'" [valueField]="'id'"
                                    style="display:inline-block; background-color:white; margin-right:1em;">
                                  </kendo-combobox>
                                </div>
                                <div>
                                  <!--Change Task Assignee-->
                                  <kendo-combobox class="w-100 mt-2"
                                    *ngIf="channelForm.controls.updateRules.controls[i].controls.updateType.value === 'CHANGE_TASKS_ASSIGNEE'"
                                    required [data]="updateRulesStaffFiltered" formControlName="assignee"
                                    [textField]="'name'" [valueField]="'id'" [filterable]="true"
                                    (filterChange)="updateRulesStaffFilter($event)" [itemDisabled]="staffItemDisabled"
                                    (close)="searchTerm=''" [placeholder]="'TYPE-OR-SELECT' | translate">
                                    <ng-template kendoComboBoxItemTemplate let-dataItem>
                                      <span innerHTML="{{ dataItem.name | highlight : searchTerm }}">
                                      </span>
                                    </ng-template>
                                  </kendo-combobox>
                                  <!--Change Task Priority-->
                                  <kendo-combobox class="w-100 mt-2"
                                    *ngIf="channelForm.controls.updateRules.controls[i].controls.updateType.value === 'CHANGE_TASKS_PRIORITY'"
                                    required [data]="listPriorities" formControlName="priority" [textField]="'text'"
                                    [valueField]="'value'" [placeholder]="'TYPE-OR-SELECT' | translate">
                                    <ng-template kendoComboBoxItemTemplate let-dataItem>
                                      <span innerHTML="{{ dataItem.text | uppercase | translate }}">
                                      </span>
                                    </ng-template>
                                  </kendo-combobox>
                                  <!--Close Conditional Wait-->
                                  <kendo-combobox class="w-100 mt-2"
                                    *ngIf="channelForm.controls.updateRules.controls[i].controls.updateType.value === 'CLOSE_CONDITIONAL_WAIT' 
                                  && channelForm.controls.updateRules.controls[i].controls.conditionalWaitId.value !== null" required
                                    [data]="mapOutcomes.get(channelForm.controls.updateRules.controls[i].controls.conditionalWaitId.value.id)"
                                    formControlName="outcome" [textField]="'outcome'" [valueField]="'outcome'"
                                    [placeholder]="'TYPE-OR-SELECT' | translate">
                                    <ng-template kendoComboBoxItemTemplate let-dataItem>
                                      <span innerHTML="{{ dataItem.outcome | uppercase }}">
                                      </span>
                                    </ng-template>
                                  </kendo-combobox>
                                  <kendo-combobox class="w-100 mt-2"
                                    *ngIf="channelForm.controls.updateRules.controls[i].controls.updateType.value === 'CLOSE_CONDITIONAL_WAIT' 
                                  && channelForm.controls.updateRules.controls[i].controls.conditionalWaitId.value === null" required
                                    [data]="listOutcomes" formControlName="outcome" [textField]="'outcome'"
                                    [valueField]="'outcome'" [placeholder]="'TYPE-OR-SELECT' | translate">
                                    <ng-template kendoComboBoxItemTemplate let-dataItem>
                                      <span innerHTML="{{ dataItem.outcome | uppercase }}">
                                      </span>
                                    </ng-template>
                                  </kendo-combobox>
                                </div>
                              </div>
                              <div class="k-tooltip k-tooltip-validation" role="alert" [hidden]="channelForm.controls.updateRules.controls[i].controls.taskIds.valid || 
                                        channelForm.controls.updateRules.controls[i].controls.taskIds.pristine">
                                {{ 'UPDATE-TASK-REQUIRED' | translate }}
                              </div>
                            </div>
                            <div class="col-sm-1" [formGroupName]="i" style="display: contents;">
                              <!--Delete Update Rules-->
                              <i class="fas fa-fw fa-times-circle fa-delete-custom" title="{{ 'DELETE' | translate }}"
                                *ngIf="!disableFormControl()"
                                (click)="removeUpdateRule(i,channelForm.controls.updateRules.controls[i].controls.id.value)">
                              </i>
                            </div>
                          </div>
                        </div>
                        <!-- Add a new rule -->
                        <div class="mb-3 ml-2">
                          <button kendoButton [primary]="false" type="button" (click)="onAddUpdateRules()"
                            [disabled]="channel.bpmId === null || disableFormControl()">
                            {{'ADD-FULFILLMENT-RULES' | translate}}<i class="far fa-plus"></i>
                          </button>
                        </div>
                      </ng-container>
                    </ng-template>
                  </kendo-tabstrip-tab>
                </kendo-tabstrip>
              </div>
            </div>
          </div>
        </div>
        <!-- Channel Goals -->
        <div class="secondary-card mt-4">
          <div class="secondary-card-header">
            <h5 class="collapsible-text" (click)="channelGoalsCollapsible.toggleChange()">
              {{'PROGRAM-GOALS-SECTION-HEADER' |
              translate}}
              <app-collapsible #channelGoalsCollapsible [storageKey]="'channel-edit-goals'"
                (collapsibleToggle)="channelGoalsCollapsed=$event">
              </app-collapsible>
            </h5>
          </div>
          <div class="card-body" *ngIf="!channelGoalsCollapsed">
            <div class="row">
              <!-- goals -->
              <div class="col-sm-6">
                <span class="k-text-uppercase dark k-form-field">{{'TARGETS' | translate}}</span>
                <form novalidate [formGroup]="goalForm">
                  <kendo-grid #goalsGrid [data]="goals" (cancel)="goalCancelHandler($event)"
                    (save)="goalSaveHandler($event)" (add)="goalAddHandler($event)" (edit)="goalEditHandler($event)">
                    <kendo-grid-messages noRecords="{{ 'NO-TARGETS' | translate }}">
                    </kendo-grid-messages>
                    <kendo-grid-column field="type" title="{{'PROGRAM-SUCCESS-TARGET' | translate}}" [width]="40">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <span>{{getGoalTypeText(dataItem.type)}}</span>
                      </ng-template>
                      <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-isNew="isNew">
                        <kendo-combobox *ngIf="isNew" id="channelGoalDropdown" [data]="goalTypes"
                          [(value)]="newGoalType" [disabled]="true" [valuePrimitive]=" true" [valueField]="'value'"
                          [textField]="'text'">
                        </kendo-combobox>
                        <span *ngIf="!isNew">{{getGoalTypeText(dataItem.type)}}</span>
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="timeline" format="{0:n0}" editor="numeric"
                      title="{{'PROGRAM-SUCCESS-TIME' | translate}}" [width]="20" class="text-center">
                      <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                        <kendo-numerictextbox [format]="'n0'" formControlName="timeline" [min]="0"
                          [max]="channelGoalMaxDays">
                        </kendo-numerictextbox>
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="success" format="{0:n0}" editor="numeric"
                      title="{{'PROGRAM-OVERALL-SUCCESS' | translate}}" [width]="20" class="text-center">
                      <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                        <kendo-numerictextbox [format]="'n0'" formControlName="success" [min]="0" [max]="100">
                        </kendo-numerictextbox>
                      </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-command-column [width]="15" class="text-center" [hidden]="disableFormControl()">
                      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex" let-isNew="isNew">
                        <ng-container *ngIf="!dataItem.editing">
                          <i class="fas fa-edit fa-lg" title="{{'EDIT' | translate}}"
                            (click)="goalEditButton.click.emit($event); dataItem.editing = true;"></i>
                          &nbsp;
                          <i class="fas fa-trash-alt fa-lg" title="{{'DELETE' | translate}}"
                            (click)="goalRemoveButton.click.emit($event); goalDeleteHandler(dataItem);"></i>
                          <button kendoGridEditCommand #goalEditButton class="d-none"></button>
                          <button kendoGridRemoveCommand #goalRemoveButton class="d-none"></button>
                        </ng-container>
                        <ng-container *ngIf="dataItem.editing">
                          <ng-container
                            *ngIf="newGoalType !== null && newGoalType !== undefined && dataItem.timeline !== null && dataItem.timeline >= 0">
                            <i class="fas fa-check fa-lg icon-success pointer" title="{{'SAVE' | translate}}"
                              (click)="goalSaveButton.click.emit($event)">
                            </i>
                            &nbsp;
                          </ng-container>
                          <i class="fas fa-times-circle fa-lg icon-neutral pointer" title="{{'CANCEL' | translate}}"
                            (click)="goalCancelButton.click.emit($event); dataItem.editing = false;"></i>
                          <button kendoGridSaveCommand #goalSaveButton class="d-none"></button>
                          <button kendoGridCancelCommand #goalCancelButton class="d-none"></button>
                        </ng-container>
                      </ng-template>
                    </kendo-grid-command-column>
                    <button kendoGridAddCommand #goalAddButton class="d-none"></button>
                  </kendo-grid>
                </form>
                <button kendoButton type="button" class="float-right mt-3" (click)="goalAddButton.click.emit($event)"
                  [disabled]="disableFormControl() || addGoalDisabled()">
                  {{'ADD-TARGET' | translate}}<i class="far fa-plus"></i>
                </button>
              </div>
              <!-- success description -->
              <div class="col-sm-6">
                <label class="k-form-field mb-0">
                  <span class="k-text-uppercase dark">{{'PROGRAM-DESCRIPTION' | translate}}</span>
                  <textarea kendoTextArea rows="5" formControlName="comments" class="w-100"></textarea>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid mt-3">
          <div class="row">
            <!-- channel test member button -->
            <div class="text-right text-nowrap" class="col-4 pl-0">
              <button appPreventClick kendoButton [hidden]="!visibleTestMember()"
                [disabled]="disableTestMember() || channel.deployedBpmId === null" (click)="createTestMember()"
                class="mt-2">
                {{'ENROLL-TEST-MEMBER' | translate:patientLabel}}<i class="far fa-user-plus"></i>
              </button>
            </div>
            <!-- channel status buttons -->
            <div *ngIf="channel.status !== 'Template'" class="col-5 d-flex justify-content-center">
              <div class="row">
                <button kendoButton [disabled]="disableOffline()" (click)="setStatus('Offline')" id="draft"
                  class="mr-3 mt-2" style="min-width:135px">
                  {{'OFFLINE' | translate}}
                </button>
                <button kendoButton [disabled]="disableOnline()" (click)="setStatus('Online')" id="publish"
                  class="mr-3 mt-2" style="min-width:135px">
                  {{'ONLINE' | translate}}
                </button>
                <button kendoButton [disabled]="disableTest()" (click)="setStatus('Simulated')" id="simulated"
                  class="mr-3 mt-2" style="min-width:135px">
                  {{'SIMULATED' | translate}}
                </button>
                <button kendoButton [disabled]="disableRetire()" (click)="setStatus('Archived')" id="retire"
                  class="mr-3 mt-2" style="min-width:135px">
                  {{'ARCHIVED' | translate}}
                </button>
              </div>
            </div>
            <!-- save & delete buttons -->
            <div class="col-3 pr-0" [ngClass]="{'col-8': channel.status === 'Template'}">
              <div class="row float-right mr-0">
                <button *ngIf="channel.status !== 'Template'" kendoButton [disabled]="disableDelete()"
                  (click)="open('deleteDialog')" id="delete" class="mr-3 mt-2">
                  {{'DELETE' | translate}}
                </button>
                <button appPreventClick #submitButton kendoButton [disabled]="disableSave()" (click)="onSubmit();"
                  class="mt-2">
                  {{'SAVE' | translate}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </ng-template>
  </kendo-tabstrip-tab>
  <kendo-tabstrip-tab title="{{ 'AUDIT' | translate }}">
    <ng-template kendoTabContent>
      <div class="content-background pt-0">
        <app-channel-audit-list [channelId]="channel.id"></app-channel-audit-list>
      </div>
    </ng-template>
  </kendo-tabstrip-tab>
</kendo-tabstrip>

<!--Delete confirmation-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="deleteDialogOpened" (close)="close('deleteDialog')"
  [minWidth]="250" [width]="450">
  <p>{{ 'CONFIRM-CHANNEL-DELETION' | translate }}</p>
  <span class="k-font-weight-bold">{{name.value}}</span>
  <kendo-dialog-actions>
    <button kendoButton (click)="deleteAction(false)">{{ 'NO' | translate }}</button>
    <button appPreventClick kendoButton (click)="deleteAction(true)" [primary]="true">{{ 'YES' | translate }}</button>
  </kendo-dialog-actions>
</kendo-dialog>

<!-- case form dialog -->
<kendo-dialog [width]="1500" *ngIf="memberDialogOpened" (close)="memberDialogOpened = false">
  <kendo-dialog-titlebar>
    <h3>{{'ENROLL-A-MEMBER-TO' | translate:patientLabel}} {{channel.name | truncate: 35}}</h3>
  </kendo-dialog-titlebar>
  <app-patient-edit [isNew]="true" #memberEdit [channelId]="channel.id" (saved)="onMemberAdded()">
  </app-patient-edit>
  <kendo-dialog-actions>
    <button kendoButton type="button" (click)="memberDialogOpened = false">
      {{ 'CANCEL' | translate}}
    </button>
    <button appPreventClick preventTime="8000" kendoButton type="button"
      [disabled]="!memberEdit.formValid() || memberEdit.formSaving()" (click)="memberEdit.apply();">
      {{ 'APPLY' | translate}}
    </button>
    <button appPreventClick preventTime="8000" kendoButton type="button"
      [disabled]="!memberEdit.formValid() || memberEdit.formSaving()" (click)="memberEdit.save();">
      {{ 'SAVE' | translate}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog title="{{ 'ENROLL-TEST-MEMBER' | translate:patientLabel }}" *ngIf="enrollTestMemberConfirmationOpened"
  (close)="enrollTestMemberConfirmationOpened=false" [minWidth]="250" [width]="450">
  <p>{{ 'CONFIRM-ENROLL-TEST-MEMBER' | translate:patientLabel }}</p>
  <kendo-dialog-actions>
    <button kendoButton (click)="enrollTestMemberConfirmationOpened=false">{{ 'NO' | translate }}</button>
    <button appPreventClick kendoButton (click)="createTestMemberAction()" [primary]="true">{{ 'YES' | translate
      }}</button>
  </kendo-dialog-actions>
</kendo-dialog>

<!--Assigned Groups Details-->
<kendo-dialog title="{{ 'INFO-GROUP-MEMBERS' | translate }}" *ngIf="showGroupMembersOpened"
  (close)="showGroupMembersOpened=false" [width]="600">
  <div class="text-center mb-2">
    <span class="pr-4">{{'GROUPS-DISPLAY-BY' | translate }}:</span>
    <input type="radio" value="group" name="groupByViewMode" [(ngModel)]="groupByViewMode" checked
      id="radioGroupByGroupView" kendoRadioButton />
    <label class="k-radio-label" for="radioGroupByGroupView">{{'GROUPS-BY-PROGRAM-GROUPS' | translate}}</label>
    <input type="radio" value="staff" name="groupByViewMode" [(ngModel)]="groupByViewMode" class="ml-3" checked
      id="radioGroupByUserView" kendoRadioButton />
    <label class="k-radio-label" for="radioGroupByUserView">{{'GROUPS-BY-PROGRAM-STAFF' | translate}}</label>
  </div>
  <div style="max-height: 400px">
    <!--Show by Groups-->
    <div *ngIf="groupByViewMode === 'group'">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>
              <label class="control-label font-weight-normal">{{ 'GROUPS-BY-PROGRAM-GROUPS' | translate }}
              </label>
            </th>
            <th>
              <label class="control-label font-weight-normal">{{ 'GROUPS-BY-PROGRAM-STAFF' | translate }}
              </label>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let group of groupByViewModeGroup">
            <td class="font-weight-bold" style="width:60%">
              {{group.name}}
            </td>
            <td style="width:40%">
              <div *ngFor="let user of group.users">
                <span [ngClass]="{'disabled-record-text': !user.enabled}">{{user.name}}</span>&nbsp;<span
                  class="disabled-record-text">{{setRecordStateText(user)}}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--Show by Staff-->
    <div *ngIf="groupByViewMode === 'staff'">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>
              <label class="control-label font-weight-normal">{{ 'GROUPS-BY-PROGRAM-STAFF' | translate }}
              </label>
            </th>
            <th>
              <label class="control-label font-weight-normal">{{ 'GROUPS-BY-PROGRAM-GROUPS' | translate }}
              </label>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of groupByViewModeStaff">
            <td style="width:40%">
              <span [ngClass]="{'disabled-record-text': !data.user.enabled, 'font-weight-bold': data.user.enabled}">
                {{data.user.name}}
              </span>&nbsp;<span class="disabled-record-text">{{setRecordStateText(data.user)}}</span>
            </td>
            <td style="width:50%">
              <div *ngFor="let group of data.groups">
                <span>{{group.name}}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <kendo-dialog-actions>
    <button kendoButton (click)="showGroupMembersOpened=false" [primary]="true">{{ 'CLOSE' | translate }}</button>
  </kendo-dialog-actions>
</kendo-dialog>